export default __webpack_public_path__ + "static/media/sheep_roller.aa4a2b4a.jpg";